import { render, staticRenderFns } from "./ShootingGalleryByType.vue?vue&type=template&id=3179a6dd&scoped=true"
import script from "./ShootingGalleryByType.vue?vue&type=script&lang=js"
export * from "./ShootingGalleryByType.vue?vue&type=script&lang=js"
import style0 from "./ShootingGalleryByType.vue?vue&type=style&index=0&id=3179a6dd&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3179a6dd",
  null
  
)

export default component.exports